export default __webpack_public_path__ + "static/media/lesovoz.60b8326f.svg";